import { Card, Link, Typography, Box } from '@mui/material';
import GatewaySeverityIndicator from '@/components/indicators/GatewaySeverityIndicator';
// Inside your component:

const NoEnergyGroupFoundCard = ({ handleEnergyGroupCreate }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Typography variant="subtitle1" mb={1}>
        Manglende opsætning
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: 2, // adds spacing below the icon
        }}
      >
        <GatewaySeverityIndicator severity="medium" />
      </Box>
      <Typography variant="body2" color="textSecondary" mb={2}>
        For at bruge EnergyXplorer skal du have en energigruppe oprettet.
      </Typography>
      <Link
        sx={{ cursor: 'pointer' }}
        underline="hover"
        onClick={handleEnergyGroupCreate}
      >
        {' '}
        Start med at oprette en energigruppe her
      </Link>
    </Card>
  );
};

export default NoEnergyGroupFoundCard;
